import { TextField } from '@mui/material';
import { AddUserFormValues } from '@src/hooks/api/mutations/useUserCreate';
import { useFormContext } from 'react-hook-form';

function PasswordField() {
  const {
    register,
    formState: { errors },
  } = useFormContext<AddUserFormValues>();

  return (
    <TextField
      fullWidth
      label='Temporary Password'
      {...register('password')}
      error={!!errors.password}
      helperText={errors.password?.message}
      type='password'
      size='small'
    />
  );
}

export default PasswordField;
